import { useState } from "react";
import { AreaField, TextField, contentToText, embedsToText, textToContent, textToEmbeds } from "@/components/admin/fields";

export const ArtistForm = ({ initial, onSubmit, submitting }) => {
  const [f, setF] = useState({
    name: "", image: "", excerpt: "",
    ...initial,
    tagsText: (initial?.tags || []).join(", "),
    contentText: contentToText(initial?.content),
    embedsText: embedsToText(initial?.embeds),
  });
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    onSubmit({
      name: f.name,
      image: f.image,
      excerpt: f.excerpt,
      tags: f.tagsText.split(",").map((t) => t.trim()).filter(Boolean),
      content: textToContent(f.contentText),
      embeds: textToEmbeds(f.embedsText),
    });
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="artist-form">
      <TextField label="Nom *" value={f.name} onChange={set("name")} required testId="artist-form-name" />
      <TextField label="Styles (séparés par des virgules)" value={f.tagsText} onChange={set("tagsText")} placeholder="Hip-Hop, Jazz, Funk" testId="artist-form-tags" />
      <TextField label="Photo (URL)" value={f.image} onChange={set("image")} placeholder="https://..." testId="artist-form-image" />
      <AreaField label="Résumé" value={f.excerpt} onChange={set("excerpt")} rows={3} testId="artist-form-excerpt" />
      <AreaField label="Biographie" value={f.contentText} onChange={set("contentText")} rows={10} testId="artist-form-content" hint="Une ligne vide entre chaque paragraphe. « ## » en début de ligne pour un intertitre." />
      <AreaField label="Vidéos / players" value={f.embedsText} onChange={set("embedsText")} rows={3} testId="artist-form-embeds" hint="Un lien par ligne (YouTube, Bandcamp, Mixcloud, SoundCloud…)." />
      <button type="submit" disabled={submitting} data-testid="artist-form-submit" className="bg-primary text-white font-display uppercase text-lg px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200 disabled:opacity-50">
        Enregistrer
      </button>
    </form>
  );
};
